import { ThunkResolvedStatus } from "@/libs/enum/ThunkResolvedStatus";
import { PHARMACY_USER_TYPE } from "@/redux/slice/auth/enums/PharmacyUserType";
import { SignedinState } from "@/redux/slice/auth/enums/SignedInState";
import { AuthState } from "@/redux/slice/auth/types/AuthState";
import patientDetailsAdapter from "@/redux/slice/auth/adapter/patientDetails";

const initialPatientDetails = patientDetailsAdapter.getInitialState();

const authInitialState: AuthState = {
  thunkStatus: {
    fetchUserType: ThunkResolvedStatus.idle,
    fetchUserCorporateTag: ThunkResolvedStatus.idle,
    authSignOut: ThunkResolvedStatus.idle,
    externalAuthVerified: ThunkResolvedStatus.idle,
  },
  authToken: "",
  currentPatientId: "",
  patientDetails: initialPatientDetails,
  ssoToken: "",
  consentAuthData: null,
  askForConsent: false,
  userConsent: false,
  signedInStatus: SignedinState.UNRESOLVED,
  userType: PHARMACY_USER_TYPE.NEW,
  newUser: false,
  tokenRefresh: false,
  tokenRecievedFetchPatients: false,
  signInError: false,
  miniAppErrorCode: 0,
  corporateTag: "",
  userOnboarded: null,
  openLoginModal: false,
  segmentInfo: null,
};

export default authInitialState;
